export function normalizeCity(city) {
	if (!city) return null;
	// Удаляем только явный префикс "г." или "город " в начале строки
	return city
		.replace(/^г\.\s*/i, "")
		.replace(/^город\s+/i, "")
		.trim();
}

export function normalizeStreet(street) {
	if (!street) return null;
	// Удаляем только явный префикс "ул." или "улица " в начале строки
	return street
		.replace(/^ул\.\s*/i, "")
		.replace(/^улица\s+/i, "")
		.trim();
}

export function normalizeHouse(house) {
	if (!house) return null;
	// Удаляем только явный префикс "д." или "дом " в начале строки
	return house
		.replace(/^д\.\s*/i, "")
		.replace(/^дом\s+/i, "")
		.trim();
}

export function normalizeApartment(apartment) {
	if (!apartment) return null;
	// Удаляем только явный префикс "кв." или "квартира " в начале строки
	return apartment
		.replace(/^кв\.\s*/i, "")
		.replace(/^квартира\s+/i, "")
		.trim();
}


export const formatDate = (dateString) => {
	const date = new Date(dateString);
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();
	return `${day}.${month}.${year}`;
};

export const formatDateWithoutYear = (dateString) => {
	const date = new Date(dateString);
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	return `${day}.${month}.`;
};

export const formatTime = (dateString) => {
	const date = new Date(dateString);
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	return `${hours}:${minutes}`;
};

export const formattedText = (text) => {
	// return text.replace(/&nbsp;/g, " ");
	return text.replace(/&nbsp;/g, "\u00A0");
};

export function phoneFormatter(phone) {
	if (!phone) return '';

	// Удаляем все нецифровые символы
	const digitsOnly = phone.replace(/\D/g, '');

	// Если номер начинается с 7, заменяем на +7
	if (digitsOnly.startsWith('7')) {
		return `+${digitsOnly}`;
	}

	// Если номер начинается с 8, заменяем на +7
	if (digitsOnly.startsWith('8')) {
		return `+7${digitsOnly.slice(1)}`;
	}

	// Для других случаев просто добавляем +
	return `+${digitsOnly}`;
};

export const formatText = (text) => {
	let formattedText = text.replace(/\r?\n/g, "<br>");

	const urlPattern = /(?<!<a href=")(https?:\/\/[^\s]+)(?!")/g;

	formattedText = formattedText.replace(urlPattern, '<a href="$1" target="_blank">$1</a>');

	return formattedText;
};